export default __webpack_public_path__ + "static/orgDesign-d1f45f731d370dee96c5c2a317236c3d.png";